import { Component, OnInit } from '@angular/core';
import { HeaderStyleTwoComponent } from '../header-style-two/header-style-two.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';

@Component({
    selector: 'app-blog-details-page',
    templateUrl: './blog-details-page.component.html',
})
export class BlogDetailsPageComponent implements OnInit {

    isToggled = false;
    referenceId: string;
    constructor(
        public themeService: ThemeCustomizerService,
        private route: ActivatedRoute
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.route.paramMap.subscribe(params => {
            this.referenceId = params.get('referenceId');
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void { }

}